export default "__VITE_PUBLIC_ASSET__7c2a4990__"